import { CanActivateFn, Router } from '@angular/router';
import { ExpedienteService } from '../expediente.service';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { Constants } from '../../constants/constants';
import { UserDataDto } from '../../dto/auth/user-data.dto';

export const expedienteGuard: CanActivateFn = (route, state) => {
  const expedienteService = inject(ExpedienteService);
  const router = inject(Router);
  const expedienteId = route.params['expedienteId'];
  let idUsuario = 0;
  let idTipoUsuarioFuncional = 0;
  const usuario = sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE);
  if (usuario) {
    const userData: UserDataDto = JSON.parse(usuario);
    idUsuario = userData.idUsuario ?? 0;
    if(userData.tipoUsuario?.Tipo_Usuario === Constants.TIPOS_USUARIO.ADMIN_FUNCIONAL){
      idTipoUsuarioFuncional = userData.tipoUsuario?.Id ?? 0;
    }
  }

  return expedienteService.getPermisoExpedienteUsuarioById(idUsuario, expedienteId, idTipoUsuarioFuncional).pipe(
    map(response => {
      if (response?.success) {
        return true;
      } else {
        router.navigate(['/']);
        return false;
      }
    }),
    catchError(error => {
      console.error(error);
      router.navigate(['/']);
      return of(false);
    })
  );
};
